import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';
import VerbTable from '../../../../../shared/components/VerbTable';
// import { titleCase } from '../../../../../shared/utils/StringUtils';

export const teamLeadRow = (props) => {
    if (!props.profile) {
        return null;
    }
    const {
        profile: { _id, firstName = '', lastName = '', email = '' } = {},
        flagForRemoval,
        isFlaggedForRemoval
    } = props;
    return (
        <tr key={_id} className={'team-lead-row'}>
            <td className={'buttonCell'}>
                <VerbButton
                    buttonType={
                        isFlaggedForRemoval
                            ? VERB_BUTTON_TYPE.SECONDARY_DETAILS_SELECTED
                            : VERB_BUTTON_TYPE.SECONDARY_DETAILS
                    }
                    fontAwesomeIcon={'fa-trash'}
                    type={'button'}
                    onClick={() => flagForRemoval(_id)}
                />
            </td>
            <td>{`${firstName || ''} ${lastName || ''}`}</td>
            <td>{email}</td>
        </tr>
    );
};

teamLeadRow.propTypes = {
    profile: PropTypes.shape({
        _id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string
    }),
    flagForRemoval: PropTypes.func,
    isFlaggedForRemoval: PropTypes.bool
};

export const TeamLeadsTable = (props) => {
    const { teamLeads = [], flagForRemoval, teamLeadsToRemove = [] } = props;

    const tableHeader = (
        <thead>
            <tr>
                <th className={'buttonCell'}>Actions</th>
                <th>Name</th>
                <th>Email</th>
            </tr>
        </thead>
    );

    return (
        <VerbTable
            className={'manage-table team-leads-table'}
            headerComponent={tableHeader}
            isHover
            isResponsive={true}
        >
            <tbody>
                {teamLeads.map((profile) => {
                    if (profile) {
                        const isFlaggedForRemoval = teamLeadsToRemove.indexOf(profile._id) > -1;
                        return teamLeadRow({ profile, flagForRemoval, isFlaggedForRemoval });
                    }
                    return null;
                })}
            </tbody>
        </VerbTable>
    );
};

TeamLeadsTable.propTypes = {
    teamLeads: PropTypes.array,
    teamLeadsToRemove: PropTypes.array,
    flagForRemoval: PropTypes.func
};

// TODO: mark members to delete as selected
export const teamMemberRow = (props) => {
    if (!props.profile) {
        return null;
    }
    const {
        profile: { _id, firstName = '', lastName = '', email = '', employeeNumber = '', employeeNumberCollection = '' } = {},
        flagForRemoval,
        isFlaggedForRemoval,
        // isTeamLead,
        // teamLeadLabel,
    } = props;

    // const isCompanyAdmin = (permissionRoles || []).some((roleObject) => roleObject.role === 'AccountOwner');

    // let teamLeadText = '';
    // if (isTeamLead) {
    //     teamLeadText = teamLeadLabel;
    // } else if (isCompanyAdmin) {
    //     teamLeadText = 'Company Admin';
    // }

    return (
        <tr key={_id} className={'team-member-row'}>
            <td className={'buttonCell'}>
                <VerbButton
                    buttonType={
                        isFlaggedForRemoval
                            ? VERB_BUTTON_TYPE.SECONDARY_DETAILS_SELECTED
                            : VERB_BUTTON_TYPE.SECONDARY_DETAILS
                    }
                    fontAwesomeIcon={'fa-trash'}
                    type={'button'}
                    onClick={() => flagForRemoval(_id)}
                />
            </td>
            <td>{`${firstName || ''} ${lastName || ''}`}</td>
            {/* <td>{email}</td> */}
            {/* <td>{teamLeadText}</td> */}
            <td>{employeeNumberCollection ?? ''}</td>
        </tr>
    );
};

teamMemberRow.propTypes = {
    flagForRemoval: PropTypes.func,
    profile: PropTypes.shape({
        _id: PropTypes.string,
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        email: PropTypes.string
    }),
    isTeamLead: PropTypes.bool,
    isFlaggedForRemoval: PropTypes.bool,
    teamLeadLabel: PropTypes.string,
};

export const TeamMembersTable = (props) => {
    const {
        teamMembers = [],
        teamLeads = [],
        flagForRemoval,
        membersToRemove = [],
        // teamLeadLabel = 'TEAM_LEAD',
        sortOrder,
        sortKey,
        setSortKey,
        teamId,
        membersToAdd,
    } = props;
    // const formattedTeamLeadLabel = titleCase(teamLeadLabel.split('_').join(' '));

    const [members, setMembers] = useState([]);

    useEffect(() => {
        let sortedMembers = [];

        const order = sortOrder === 1 ? 'asc' : 'desc';

        // sort by team join date
        if (sortKey === 'default') {
            const membersWithTeamAddDate = teamMembers.map((member) => {
                if (member?.teams?.length) {
                    member.teams.forEach(({ teamId: teamMemberId, joinedDateTime }) => {
                        if (teamMemberId === teamId) {
                            member.joinedTime = new Date(joinedDateTime);
                        }
                    });
                }
                return member;
            });
            membersWithTeamAddDate.sort((a, b) => {
                const dateA = new Date(a.joinedTime);
                const dateB = new Date(b.joinedTime);
                return dateB - dateA;
            });
            sortedMembers = [...membersWithTeamAddDate];
        }

        if (sortKey === 'name') {
            sortedMembers = orderBy(
                teamMembers,
                [(user) => (user.firstName ? user.firstName.toLowerCase() : null)],
                [order]
            );
        }

        if (sortKey === 'email') {
            sortedMembers = orderBy(teamMembers, [(user) => (user.email ? user.email.toLowerCase() : null)], [order]);
        }

        if (sortKey === 'role') {
            const membersWithRoleValue = teamMembers.map((member) => {
                let roleValue = -1;

                if (teamLeads.indexOf(member._id) > -1) {
                    roleValue = 0;
                }

                if ((member.permissionRoles || []).some((roleObject) => roleObject.role === 'AccountOwner')) {
                    roleValue = 1;
                }

                member.roleValue = roleValue;
                return member;
            });
            sortedMembers = orderBy(membersWithRoleValue, ['roleValue'], [order]);
        }

        if (sortKey === 'employeeNumber') {
            const membersWithEmployeeNumber = teamMembers.map((member) => {
                const employeeNumToSort= (member.employeeNumberCollection?.split(', ') ?? [])[0];
                if (Number.isNaN(Number(employeeNumToSort[0]))) {
                    member.employeeNum = employeeNumToSort;
                } else {
                    member.employeeNum = Number(employeeNumToSort);
                }
                return member;
            });
            sortedMembers = orderBy(membersWithEmployeeNumber, ['employeeNum'], [order]);
        }
        setMembers(sortedMembers);
    }, [sortKey, sortOrder, teamMembers]);

    const tableHeader = (
        <thead>
            <tr>
                <th className={'buttonCell'}>Actions</th>
                <th className={'sortable-header'} onClick={() => setSortKey('name')}>
                    Name
                </th>
                {/* <th className={'sortable-header'} onClick={() => setSortKey('email')}>
                    Email
                </th> */}
                {/* <th className={'sortable-header'} onClick={() => setSortKey('role')}>
                    Role
                </th> */}
                <th className={'sortable-header'} onClick={() => setSortKey('employeeNumber')}>
                    Employee #
                </th>
            </tr>
        </thead>
    );
    
    const updatedMembers = [
        ...members,
        ...membersToAdd
    ];

    if (!updatedMembers.length) {
        return <div> This team currently has no registered members. </div>;
    }

    return (
        <VerbTable
            className={'manage-table team-members-table'}
            headerComponent={tableHeader}
            isHover
            isResponsive={true}
        >
            <tbody>
                {updatedMembers.map((profile) => {
                    if (profile) {
                        // const isTeamLead = teamLeads.indexOf(profile._id) > -1;
                        const isFlaggedForRemoval = membersToRemove.indexOf(profile._id) > -1;
                        return teamMemberRow({
                            profile,
                            // isTeamLead,
                            flagForRemoval,
                            isFlaggedForRemoval,
                            // teamLeadLabel: formattedTeamLeadLabel,
                        });
                    }
                    return null;
                })}
            </tbody>
        </VerbTable>
    );
};

TeamMembersTable.propTypes = {
    teamMembers: PropTypes.array,
    teamLeads: PropTypes.array,
    flagForRemoval: PropTypes.func,
    membersToRemove: PropTypes.array,
    teamLeadLabel: PropTypes.string,
    setSortKey: PropTypes.func,
    sortOrder: PropTypes.number,
    sortKey: PropTypes.string,
    teamId: PropTypes.string,
};
